<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
        <bita-ibox :is-loading="isLoadingModal">
            <div slot="body">
                <div class="row">
                    <bita-input
                        type="text"
                        name="national_code"
                        label="کدملی راننده"
                        rules="irani"
                        validation-container-class="col-lg-6"
                        input-class="form-control"
                        v-model.lazy="driver_national_code"
                        @change="findDriver"
                        subtitle="جستجو فقط با کد‌ملی کامل و صحیح"
                    />
                    <bita-ibox :is-loading="isLoadingGrid">
                        <div slot="body">
                        <bita-grid
                            v-if="showGrid"
                            ref="driverGrid"
                            name="driverGrid"
                            :columns="gridColumns"
                            :read-data="readData"
                            :hasRow="false"
                        />
                        </div>
                    </bita-ibox>
                </div>
            </div>
        </bita-ibox>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="propsData.id"
        type="primary"
        title="بروزرسانی"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
    props: {
        modalId: String,
        isLoading: Boolean,
        propsData: Object,
    },
    data() {
        return {
            driver_national_code: "",
            title: "",
            isLoadingGrid: false,
            isLoadingModal: false,
            updateForm: {},
            showGrid: false,
            gridColumns: [
                { title: "#", template: this.$getTemplate, width: "40px" },
                { field: "full_name", title: "نام" },
                { field: "national_code", title: "کدملی" },
                {
                title: "عملیات",
                command: [],
                },
            ],
        }
    },
    mounted() {
        this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    },
    methods: {
        setData(_formData) {
            this.showGrid = true;
            this.title = `رانندگان بومی ${_formData.name}`
            this.updateForm = _formData;
        },
        readData(e) {
            this.isLoadingGrid = true;
            this.$persistClient("get", `owners/${this.updateForm.id}/drivers`)
                .then((res) => {
                    e.success(res.data.drivers);
                })
                .catch(() => {
                    e.success([]);
                })
                .finally(() => {
                    this.isLoadingGrid = false;
                });
        },
        loadData() {
            this.$refs.driverGrid.loadDataSource();
        },
        gridCommands() {
        let commands = [];
        commands.push({
            text: "delete",
            click: this.delete,
            template: this.gridButtons.delete,
        });
        return commands;
        },
        delete(e) {
        let driver = this.$refs.driverGrid.getSelectedGridRow(e);
        this.$alert(
            "question",
            `آیا از حذف راننده ${driver.name} اطمینان دارید ؟`,
            "",
            {
            confirmButtonText: "بله",
            }
        ).then((result) => {
            if (result.value) {
            this.isLoadingGrid = true;
            this.$persistClient("delete", `owners/${this.updateForm.id}/drivers/${driver.id}`)
                .then((res) => {
                this.$izitoast("success", "عملیات موفق", res.data.message);
                this.loadData();
                })
                .finally(() => {
                this.isLoadingGrid = false;
                });
            }
        });
        },
        findDriver() {
            this.isLoading
            if (this.$ssnIsValid(this.driver_national_code)) {
                this.isLoadingModal = true;
                this.$persistClient("post", `drivers/national-code`, {national_code: this.driver_national_code,})
                .then((res) => {
                    if (res.data.is_success) {
                        let data = {
                            driver_id: res.data.data.id, 
                        }
                        this.$persistClient("post", `owners/${this.updateForm.id}/drivers`, data)
                            .then( (res) => {
                                this.$izitoast("success", "عملیات موفق", res.data.message);
                                this.loadData();
                            })
                            .finally( () => ( this.isLoadingModal = false ))
                    }
                }).catch((res) => {
                    this.filter = {
                        driver_id: ''
                    };
                })
                .finally( () => ( this.isLoadingModal = false ))
            }else if(this.driver_national_code == '')
                this.filter = {
                    driver_id: ''
                }
        },
        onCloseModal() {
            this.showGrid = false;
        },
        handleSubmit() {

        }
    }
}
</script>